import {
    type TeamsSubscribeAction,
    type TSubscribeActionDescriptor,
    type TTeamsSendActionsDescriptor,
    Bridge,
    TeamsSendAction,
} from '@instant-messengers/vk-teams-bridge';
import { parse } from 'qs';
import { APIConfig } from 'reactApp/api/APIConfig';
import { enableWorkspaceSuperappMode } from 'reactApp/appHelpers/featuresHelpers/features/workspaceSuperapp';
import { TokenService } from 'reactApp/services/TokenService';

export type BridgeType = Bridge<
    TeamsSubscribeAction,
    Record<TeamsSubscribeAction, TSubscribeActionDescriptor>,
    TeamsSendAction,
    TTeamsSendActionsDescriptor
>;

type InitReturnType = {
    isError: boolean;
    isEnabled: boolean;
};

class WorkspaceSuperApp {
    isEnabled = false;
    private bridge: BridgeType;
    private tokenService: TokenService;

    constructor() {
        this.bridge = new Bridge();
        this.tokenService = new TokenService(this.bridge);
    }

    async init(): Promise<InitReturnType> {
        this.isEnabled = this.checkIsSuperApp() && enableWorkspaceSuperappMode;

        if (!this.isEnabled) {
            return { isError: false, isEnabled: this.isEnabled };
        }

        const token = await this.tokenService.init();

        if (token) {
            APIConfig.set('workspace-superapp-access-token', token);
        }

        await this.bridge.send(TeamsSendAction.LoadingCompleted, {
            ok: true,
        });

        return { isError: !token, isEnabled: this.isEnabled };
    }

    private checkIsSuperApp() {
        const url = new URL(window.location.href);

        return url.searchParams.has('superapp');
    }

    getAuthToken() {
        return this.tokenService.getAuthToken();
    }

    getAuthHeaderValue() {
        return `Bearer ${this.getAuthToken()}`;
    }

    sendAuthChangeEvent(path: string, params: string) {
        if (!this.isEnabled) {
            return;
        }

        this.bridge.send(TeamsSendAction.NavigationChanged, {
            path,
            params: parse(params, { ignoreQueryPrefix: true }),
        });
    }

    refreshToken() {
        return this.tokenService.fetchAccessToken();
    }
}

export const WorkspaceSuperAppService = new WorkspaceSuperApp();
